function createAddToCartManager() {
  let components = new Map();
  let isInitialized = false;

  const registerComponent = (name, component) => {
    components.set(name, component);
  };

  const init = () => {
    if (isInitialized) return;
    
    bindEvents();
    isInitialized = true;
    document.dispatchEvent(new CustomEvent('addon-manager:ready'));
  };

  const bindEvents = () => {
    document.addEventListener('submit', (e) => {
      const form = e.target;
      const formId = form?.id || '';
      
      if ((formId.includes('product-form') || form.getAttribute('is') === 'product-form') && components.size > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleAddToCart(form);
        return false;
      }
    }, { capture: true });

    document.addEventListener('click', (e) => {
      const submitBtn = e.target.closest('button[type="submit"], [type="submit"]');
      if (submitBtn && submitBtn.closest('buy-buttons, [data-product-form]') && components.size > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const form = submitBtn.closest('form');
        if (form) {
          handleAddToCart(form);
        }
        return false;
      }
    }, { capture: true });
  };

  const handleAddToCart = async (form) => {
    const button = form.querySelector('button[type="submit"]');
    const originalText = button?.textContent;
    
    try {
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }
      const mainVariantId = form.querySelector('input[name="id"]')?.value;
      const mainQuantity = form.querySelector('input[name="quantity"]') ? 
                          parseInt(form.querySelector('input[name="quantity"]').value) : 1;
      
      if (!mainVariantId) {
        throw new Error('Main product variant ID not found');
      }
      const items = [
        {
          id: parseInt(mainVariantId),
          quantity: mainQuantity
        }
      ];

      const componentItems = collectAllItems();
      if (componentItems.length > 0) {
        items.push(...componentItems);
      }
    
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });
      
      if (response.ok) {
        const result = await response.json();
        await triggerCartUpdate();
        openCartDrawer();
        
      } else {
        const errorText = await response.text();
        let userMessage = (typeof window.__addonCartMessages !== 'undefined' && window.__addonCartMessages.add_to_cart_error) ? window.__addonCartMessages.add_to_cart_error : 'There was an error adding items to cart. Please try again.';
        if (response.status === 422) {
          try {
            const errData = JSON.parse(errorText);
            const apiMsg = errData.description || errData.message || '';
            const isMaxQtyOrStock = apiMsg && (apiMsg.includes('maximum quantity') || apiMsg.includes('already in your cart') || apiMsg.includes('stock'));
            if (isMaxQtyOrStock) {
              const inv = window.__variantInventory || {};
              const msg = window.__addonCartMessages;
              const minStock = Math.min(...items.map(function (it) { return inv[it.id] != null ? inv[it.id] : Infinity; }));
              if (Number.isFinite(minStock) && minStock >= 0 && (msg && msg.only_n_left_one != null && msg.only_n_left_units != null)) {
                userMessage = minStock === 1 ? msg.only_n_left_one : (msg.only_n_left_units || '').replace(/\{\{\s*count\s*\}\}/g, String(minStock));
              } else if (Number.isFinite(minStock) && minStock >= 0) {
                userMessage = minStock === 1 ? 'Only 1 unit left in stock.' : 'Only ' + minStock + ' units left in stock.';
              } else {
                userMessage = (msg && msg.max_quantity_in_cart) ? msg.max_quantity_in_cart : apiMsg;
              }
            } else if (apiMsg) {
              userMessage = apiMsg;
            }
          } catch (_) {}
          throw new Error(userMessage);
        }
        throw new Error(userMessage);
      }
    } catch (error) {
      console.error('❌ Error adding to cart:', error);
      showMessage(error.message || (window.__addonCartMessages && window.__addonCartMessages.add_to_cart_error) || 'There was an error adding items to cart. Please try again.', 'error');
    } finally {
      if (button && originalText) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  };

  const collectAllItems = () => {
    const items = [];
    
    for (const [name, component] of components) {
      try {
        if (component && typeof component.getItems === 'function') {
          const componentItems = component.getItems();
          if (componentItems && componentItems.length > 0) {
            items.push(...componentItems);
          }
        }
      } catch (error) {
        console.error(`Error collecting items from ${name}:`, error);
      }
    }
    
    return items;
  };

  const triggerCartUpdate = async () => {
    return new Promise((resolve) => {
      const events = ['cart:updated', 'cart:refresh', 'change:cart'];
      events.forEach(eventName => {
        document.dispatchEvent(new CustomEvent(eventName));
      });

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          updateCartCount(cart.item_count);
          resolve();
        })
        .catch(() => resolve());
      
      setTimeout(resolve, 500);
    });
  };

  const openCartDrawer = () => {
    const cartDrawer = document.getElementById('cart-drawer');
    
    if (cartDrawer) {
      if (typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      } else {
        const openEvent = new Event('open', { bubbles: true });
        cartDrawer.dispatchEvent(openEvent);
      }
    }
  };

  const updateCartCount = (count) => {
    const countElements = document.querySelectorAll([
      '.cart-count',
      '[class*="cart-count"]',
      '.header__cart-count',
      '.cart-bubble__quantity'
    ].join(','));
    
    countElements.forEach(element => {
      element.textContent = count;
    });
  };

  const showMessage = (message, type = 'info') => {
    document.querySelector('.addon-cart-toast')?.remove();
    const el = document.createElement('div');
    el.className = 'addon-cart-toast';
    el.style.cssText = `
      position: fixed; top: 20px; right: 20px; padding: 12px 20px;
      background: ${type === 'error' ? '#AA2826' : '#708A5C'}; color: white;
      border-radius: 4px; z-index: 10000; box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      font-family: system-ui, -apple-system, sans-serif; font-size: 14px;
    `;
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(() => { if (el.parentNode) el.remove(); }, 3000);
  };

  return {
    init,
    registerComponent,
    isInitialized: () => isInitialized
  };
}

window.addToCartManager = createAddToCartManager();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.addToCartManager.init();
  });
} else {
  window.addToCartManager.init();
}